import { Controller } from "@hotwired/stimulus"

// Управляет галереей внутри карточки проекта:
// - переключение главного фото по клику на миниатюру или стрелки prev/next;
// - клик по главному фото открывает lightbox (через скрытые data-lightbox-target items).
export default class extends Controller {
  static targets = ["main", "thumb", "counter"]
  static values  = { index: { type: Number, default: 0 } }

  connect() {
    this.updateActive()
  }

  select(event) {
    event?.preventDefault?.()
    const idx = parseInt(event.currentTarget.dataset.index, 10)
    if (Number.isNaN(idx)) return
    this.indexValue = idx
    this.updateMain()
  }

  prev(event) {
    event?.preventDefault?.()
    event?.stopPropagation?.()
    this.shift(-1)
  }

  next(event) {
    event?.preventDefault?.()
    event?.stopPropagation?.()
    this.shift(1)
  }

  shift(delta) {
    const total = this.thumbTargets.length || 1
    this.indexValue = (this.indexValue + delta + total) % total
    this.updateMain()
  }

  openLightbox(event) {
    event?.preventDefault?.()
    const items = this.element.querySelectorAll('[data-lightbox-target="item"]')
    const target = items[this.indexValue] || items[0]
    target?.click()
  }

  updateMain() {
    const thumb = this.thumbTargets[this.indexValue]
    if (!thumb || !this.hasMainTarget) return

    const fullUrl = thumb.dataset.full
    if (fullUrl) this.mainTarget.src = fullUrl

    if (this.hasCounterTarget) {
      this.counterTarget.textContent = `${this.indexValue + 1} / ${this.thumbTargets.length}`
    }
    this.updateActive()
  }

  updateActive() {
    this.thumbTargets.forEach((t, i) => {
      t.classList.toggle("is-active", i === this.indexValue)
    })
  }
}
